// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"459":"partner","962":"home"}[chunkId] + "." + {"459":"1ca7437a","962":"4307e943"}[chunkId] + ".css";
};